module.exports = __webpack_public_path__ + "static/img/Save Time & Money.a21c3e58.webp";